import styled from 'styled-components'
import { LabelProps } from './Label.types'
import { labelVariant } from './variant'
import Flex from '../Flex'

export const StyledLabel = styled(Flex)<LabelProps>`
  box-sizing: border-box;
  ${labelVariant};
`
